import React, { useEffect } from 'react';

const WorkflowComplete = () => {
  useEffect(() => {
    window.top.postMessage(
      {
        error: false,
        docuSignComplete: true,
      },
      '*'
    );
  }, []);

  return (
    <div>
      <h3>Docusign complete</h3>
    </div>
  );
};

export default WorkflowComplete;



// WEBPACK FOOTER //
// ./src/containers/pages/BorrowerMerchantApply/InternalPages/WorkflowComplete/index.js